export const campodigital = [

 
  // {
  //   nombre: "VENTANILLA PROGRAMA PRODUCTIVO PARA MUJER RURAL",
  //   enlace:
  //     "https://forms.gle/WEfeAWD8LQikBNPv8",
  //   anio: "2026",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1 Mujer Rural",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1DignificarMujer.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Anexo FUPS",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
  //     },
      
  //   ]

  // },
   {
    nombre: "VENTANILLA SEGURO CATÁSTROFICO AGRÍCOLA",
    enlace:
      "https://forms.gle/WWUWAL3wiU1riqr1A",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 ",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1_Catastrofes.pdf",
      },
      {
        id: "2",
        nombreformato: "Anexo FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
       
      
    ]
  },
  {
    nombre: "VENTANILLA SEGURO CATASTRÓFICO PECUARIO",
    enlace:
      "https://forms.gle/WWUWAL3wiU1riqr1A",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 ",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1_Catastrofes.pdf",
      },
      {
        id: "2",
        nombreformato: "Anexo FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
       
      
    ]
  },
  {
    nombre: "VENTANILLA ANÁLISIS DE SUELOS",
    enlace:
      "https://forms.gle/WWUWAL3wiU1riqr1A",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 Dignificar",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/AnexoDM_2.pdf",
      },
      //  {
      //   id: "2",
      //   nombreformato: "Anexo 2 Dignificar",
      //   enlaceformato:
      //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo2Dignificar.pdf",
      // },
      //  {
      //   id: "2",
      //   nombreformato: "Anexo de apoyo",
      //   enlaceformato:
      //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/AnexoApoyo.pdf",
      // },
      {
        id: "2",
        nombreformato: "Anexo FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
      
    ]

  },
  {
    nombre: "VENTANILLA MUJERES QUE TRANSFORMAN EL CAMPO (Módulo de invernadero)",
    enlace:
      "https://forms.gle/WWUWAL3wiU1riqr1A",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 Transformar",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/AnexoDM_2.pdf",
      },
      // {
      //   id: "2",
      //   nombreformato: "Anexo de apoyo",
      //   enlaceformato:
      //     "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/AnexoApoyo.pdf",
      // },
      {
        id: "2",
        nombreformato: "Anexo 2 FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
      
    ]

  },
   {
    nombre: "Ampliación a las Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/ReglasOperacion2026.pdf",
    anio: "2026",
     formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización octubre 2026",
      },
    ]
  },
   {
    nombre: "Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/ReglasOperacion2026.pdf",
    anio: "2026",
     formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización enero 2026",
      },
    ]
  },
  

  {
    nombre: "TELEFONOS",
    enlace:
      "/Contacto",
    anio: "Atención",
    formatos: [
      {
        id: "1",
        nombreformato: "Telefonos de Atención",
        enlaceformato:
          "/Contacto",
      },
      
    ]

  },
  

  
]

